import {fetchDataFromApi} from './apiHelper';

export const fetchDataFields = () => fetchDataFromApi('post', '/api/human/getdatafields');
export const fetchStatisticFields = () => fetchDataFromApi('post', '/api/human/getstatisticfields');
export const fetchSellers = () => fetchDataFromApi('post', '/api/human/getsellers');
export const fetchBundles = () => fetchDataFromApi('post', '/api/human/getbundles');
export const fetchPlatforms = () => fetchDataFromApi('post', '/api/human/getplatform');
export const fetchPublishers = () => fetchDataFromApi('post', '/api/human/getpublishers');
